import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker.ts'

createApp(App).use(router).mount('#app')
